// import React, { useMemo, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import {
//   ArrowRight,
//   BadgeCheck,
//   Box,
//   ChevronDown,
//   ClipboardList,
//   Factory,
//   Leaf,
//   Package,
//   PhoneCall,
//   ShieldCheck,
//   Star,
//   Truck,
// } from "lucide-react";

// // ✅ Replace with your real assets
// import img1 from "../../assets/products/shilajit/shilajit-capsule.png";
// import img2 from "../../assets/products/shilajit/shilajit-resin.png";
// import img3 from "../../assets/products/shilajit/shilajit-resin1.png";
// import img4 from "../../assets/products/shilajit/shilajit-resin2.png";
// import img5 from "../../assets/products/shilajit/shilajit-resin3.png";


// type TabKey =
//   | "info"
//   | "spec"
//   | "dosage"
//   | "quality"
//   | "pricing"
//   | "packaging";

// const fadeUp = {
//   hidden: { opacity: 0, y: 16 },
//   show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
// };

// const shimmer =
//   "bg-[linear-gradient(110deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.35)_35%,rgba(255,255,255,0)_70%)] bg-[length:200%_100%]";

// export default function ShilajitProductPage() {
//   const images = useMemo(
//     () => [
//       // ✅ replace with your real product images
//     //   "https://images.unsplash.com/photo-1616671276441-2f2cf7b1d37a?auto=format&fit=crop&w=1200&q=80",
//     //   "https://images.unsplash.com/photo-1585232351009-aa87416fca90?auto=format&fit=crop&w=1200&q=80",
//     //   "https://images.unsplash.com/photo-1584017911766-d451b3d0e843?auto=format&fit=crop&w=1200&q=80",
//     //   "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?auto=format&fit=crop&w=1200&q=80",
//     img1,
//     img2,
//     img3,
//     img4,
//     img5,

//     ],
//     []
//   );

//   const [activeImg, setActiveImg] = useState(0);
//   const [tab, setTab] = useState<TabKey>("info");

//   const tabs: { key: TabKey; label: string; icon: any }[] = [
//     { key: "info", label: "Product Information", icon: ClipboardList },
//     { key: "spec", label: "Product Specification", icon: Factory },
//     { key: "dosage", label: "Dosage & Usage", icon: Leaf },
//     { key: "quality", label: "Quality & Appearance", icon: ShieldCheck },
//     { key: "pricing", label: "Pricing & Supply", icon: Truck },
//     { key: "packaging", label: "Packaging & Storage", icon: Box },
//   ];

//   return (
//     <div className="relative bg-white overflow-hidden">
//       {/* Premium background (no grid) */}
//       <div className="pointer-events-none absolute inset-0">
//         <div className="absolute inset-0 bg-[radial-gradient(1100px_circle_at_15%_5%,rgba(244,124,32,0.12),transparent_60%),radial-gradient(1000px_circle_at_85%_15%,rgba(232,62,111,0.10),transparent_60%),radial-gradient(900px_circle_at_60%_95%,rgba(201,162,39,0.10),transparent_55%)]" />
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_50%,rgba(0,0,0,0.04)_100%)]" />
//       </div>

//       {/* HERO */}
//       <section className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 pt-12 md:pt-16 pb-10">
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
//           {/* Left: Copy */}
//           <motion.div
//             variants={fadeUp}
//             initial="hidden"
//             whileInView="show"
//             viewport={{ once: true, amount: 0.25 }}
//             className="lg:col-span-6"
//           >
//             <div className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 backdrop-blur">
//               <BadgeCheck size={16} className="text-[#C62828]" />
//               <span className="text-xs font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/75">
//                 Shilajit Capsules • Private Label / OEM / ODM
//               </span>
//             </div>

//             <h1 className="mt-6 text-4xl md:text-5xl font-extrabold leading-tight text-[#1B1B1B]">
//               Curated to meet needs, right from the lap of nature —{" "}
//               <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
//                 Shilajit Capsules
//               </span>
//             </h1>

//             <p className="mt-6 text-base md:text-lg leading-relaxed text-[#2B2B2B]/80">
//               We provide fully integrated services at Amera Exports for the
//               manufacture of Shilajit Capsules and can assist your business in
//               developing its brand with hassle-free manufacturing and packaging
//               solutions.
//             </p>

//             <p className="mt-4 text-base md:text-lg leading-relaxed text-[#2B2B2B]/80">
//               Our facilities are equipped with advanced machinery, and the
//               encapsulation of Shilajit is done systematically for private
//               labeling. Our product line extends to include Shilajit resin,
//               Shilajit powder, Shilajit gummies, and more.
//             </p>

//             {/* Trust chips */}
//             <div className="mt-7 flex flex-wrap items-center gap-3">
//               {[
//                 { label: "Export-ready", icon: Truck },
//                 { label: "CGMP / HACCP aligned", icon: ShieldCheck },
//                 { label: "Private label", icon: Package },
//                 { label: "Bulk supply", icon: Factory },
//               ].map((c) => (
//                 <span
//                   key={c.label}
//                   className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-4 py-2 text-sm text-[#2B2B2B]/75 shadow-sm"
//                 >
//                   <c.icon size={14} className="text-[#C62828]" />
//                   {c.label}
//                 </span>
//               ))}
//             </div>

//             {/* CTAs */}
//             <div className="mt-9 flex flex-wrap items-center gap-4">
//               <motion.a
//                 whileHover={{ y: -2 }}
//                 whileTap={{ scale: 0.98 }}
//                 href="/contact"
//                 className="relative inline-flex items-center justify-center rounded-md px-7 py-3 text-sm font-semibold text-white
//                            bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-lg shadow-black/10 hover:opacity-95 transition"
//               >
//                 INQUIRE NOW
//                 <ArrowRight size={18} className="ml-2" />
//                 <span
//                   className={`pointer-events-none absolute inset-0 rounded-md ${shimmer} opacity-40`}
//                   style={{ animation: "shimmer 3.2s linear infinite" }}
//                 />
//               </motion.a>

//               <motion.a
//                 whileHover={{ y: -2 }}
//                 whileTap={{ scale: 0.98 }}
//                 href="tel:+916387961502"
//                 className="inline-flex items-center justify-center rounded-md px-7 py-3 text-sm font-semibold
//                            border border-black/10 bg-white text-[#C62828] hover:text-[#F47C20] shadow-sm transition"
//               >
//                 <PhoneCall size={18} className="mr-2" />
//                 Talk to Sales
//               </motion.a>
//             </div>

//             {/* Mini rating strip */}
//             <div className="mt-10 flex items-center gap-3 text-sm text-[#2B2B2B]/70">
//               <div className="flex items-center gap-1 text-[#C62828]">
//                 <Star size={16} fill="currentColor" />
//                 <Star size={16} fill="currentColor" />
//                 <Star size={16} fill="currentColor" />
//                 <Star size={16} fill="currentColor" />
//                 <Star size={16} fill="currentColor" />
//               </div>
//               <span>Trusted by global brands in USA & Europe</span>
//             </div>
//           </motion.div>

//           {/* Right: Gallery */}
//           <motion.div
//             variants={fadeUp}
//             initial="hidden"
//             whileInView="show"
//             viewport={{ once: true, amount: 0.25 }}
//             className="lg:col-span-6"
//           >
//             <div className="relative">
//               {/* Glass panel */}
//               <div className="rounded-2xl border border-black/10 bg-white/70 backdrop-blur shadow-[0_30px_90px_rgba(0,0,0,0.12)] overflow-hidden">
//                 {/* Top accent */}
//                 <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

//                 <div className="p-4 md:p-6">
//                   {/* Main image */}
//                   <div className="relative rounded-2xl overflow-hidden border border-black/10 bg-white">
//                     <motion.img
//                       key={images[activeImg]}
//                       src={images[activeImg]}
//                       alt="Shilajit Capsules"
//                       className="w-full h-[300px] md:h-[380px] object-cover"
//                       initial={{ opacity: 0, scale: 0.98 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       transition={{ duration: 0.35 }}
//                       draggable={false}
//                     />
//                     <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(700px_circle_at_20%_10%,rgba(244,124,32,0.10),transparent_55%),radial-gradient(700px_circle_at_90%_30%,rgba(232,62,111,0.08),transparent_55%)]" />

//                     {/* Floating badge */}
//                     <motion.div
//                       animate={{ y: [0, -8, 0] }}
//                       transition={{ repeat: Infinity, duration: 6 }}
//                       className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-white/85 backdrop-blur border border-black/10 px-3 py-2 text-xs font-semibold text-[#2B2B2B]/80 shadow-sm"
//                     >
//                       <Leaf size={14} className="text-[#C62828]" />
//                       Natural • Potency-focused • Private Label
//                     </motion.div>
//                   </div>

//                   {/* Thumbnails */}
//                   <div className="mt-4 grid grid-cols-4 gap-3">
//                     {images.map((src, i) => (
//                       <button
//                         key={src}
//                         onClick={() => setActiveImg(i)}
//                         className={`relative rounded-xl overflow-hidden border transition ${
//                           i === activeImg
//                             ? "border-transparent ring-2 ring-[#E83E6F]/40"
//                             : "border-black/10 hover:border-black/20"
//                         }`}
//                         aria-label={`View image ${i + 1}`}
//                       >
//                         <img
//                           src={src}
//                           alt="thumb"
//                           className="h-16 md:h-20 w-full object-cover"
//                           draggable={false}
//                         />
//                         {i === activeImg && (
//                           <div className="absolute inset-0 bg-gradient-to-r from-[#F47C20]/10 to-[#E83E6F]/10" />
//                         )}
//                       </button>
//                     ))}
//                   </div>

//                   {/* Mini spec strip */}
//                   <div className="mt-5 grid grid-cols-3 gap-3">
//                     {[
//                       { k: "Form", v: "Capsules" },
//                       { k: "Support", v: "OEM/ODM" },
//                       { k: "Markets", v: "USA • EU" },
//                     ].map((m) => (
//                       <div
//                         key={m.k}
//                         className="rounded-xl border border-black/10 bg-white px-4 py-3 text-center"
//                       >
//                         <div className="text-sm font-bold text-[#C62828]">
//                           {m.k}
//                         </div>
//                         <div className="text-[11px] md:text-xs text-[#2B2B2B]/65">
//                           {m.v}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* Ambient blobs */}
//               <div className="pointer-events-none absolute -top-16 -right-16 h-64 w-64 rounded-full bg-[#E83E6F]/10 blur-3xl" />
//               <div className="pointer-events-none absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-[#F47C20]/10 blur-3xl" />
//             </div>
//           </motion.div>
//         </div>
//       </section>

//       {/* DETAILS */}
//       <section className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 pb-16 md:pb-24">
//         <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
//           {/* Left: Tabs */}
//           <div className="lg:col-span-8">
//             <div className="rounded-2xl border border-black/10 bg-white shadow-sm overflow-hidden">
//               <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

//               {/* Tab header */}
//               <div className="p-4 md:p-6 border-b border-black/5">
//                 <div className="flex flex-wrap gap-2">
//                   {tabs.map((t) => {
//                     const Icon = t.icon;
//                     const active = tab === t.key;
//                     return (
//                       <button
//                         key={t.key}
//                         onClick={() => setTab(t.key)}
//                         className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition border ${
//                           active
//                             ? "bg-gradient-to-r from-[#F47C20] to-[#E83E6F] text-white border-transparent shadow-sm"
//                             : "bg-white text-[#2B2B2B]/75 border-black/10 hover:border-black/20"
//                         }`}
//                       >
//                         <Icon size={16} />
//                         {t.label}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </div>

//               {/* Tab content */}
//               <div className="p-5 md:p-7">
//                 <AnimatePresence mode="wait">
//                   <motion.div
//                     key={tab}
//                     initial={{ opacity: 0, y: 10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: 10 }}
//                     transition={{ duration: 0.25 }}
//                   >
//                     <TabContent tab={tab} />
//                   </motion.div>
//                 </AnimatePresence>
//               </div>
//             </div>
//           </div>

//           {/* Right: Sticky CTA + Packaging summary */}
//           <div className="lg:col-span-4">
//             <div className="lg:sticky lg:top-24 space-y-6">
//               <motion.div
//                 variants={fadeUp}
//                 initial="hidden"
//                 whileInView="show"
//                 viewport={{ once: true, amount: 0.25 }}
//                 className="rounded-2xl border border-black/10 bg-white shadow-sm overflow-hidden"
//               >
//                 <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

//                 <div className="p-6">
//                   <h3 className="text-lg font-bold text-[#1B1B1B]">
//                     Packaging Details
//                   </h3>
//                   <p className="mt-2 text-sm text-[#2B2B2B]/75 leading-6">
//                     Secure, moisture-resistant packaging to maintain freshness.
//                   </p>

//                   <div className="mt-5 space-y-3">
//                     {[
//                       "Available in bottle, blister packs, or bulk packaging",
//                       "Long shelf life when stored in cool, dry conditions",
//                       "Labeling support for private brands",
//                     ].map((b) => (
//                       <div key={b} className="flex items-start gap-3">
//                         <span className="mt-2 h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
//                         <p className="text-sm text-[#2B2B2B]/80">{b}</p>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="mt-6 grid grid-cols-2 gap-3">
//                     <div className="rounded-xl border border-black/10 bg-white px-4 py-3">
//                       <div className="text-xs text-[#2B2B2B]/60">Formats</div>
//                       <div className="mt-1 text-sm font-semibold text-[#1B1B1B]">
//                         Bottle / Blister / Bulk
//                       </div>
//                     </div>
//                     <div className="rounded-xl border border-black/10 bg-white px-4 py-3">
//                       <div className="text-xs text-[#2B2B2B]/60">Storage</div>
//                       <div className="mt-1 text-sm font-semibold text-[#1B1B1B]">
//                         Cool & Dry
//                       </div>
//                     </div>
//                   </div>

//                   <motion.a
//                     whileHover={{ y: -2 }}
//                     whileTap={{ scale: 0.98 }}
//                     href="/contact"
//                     className="mt-6 inline-flex w-full items-center justify-center rounded-md px-6 py-3 text-sm font-semibold text-white
//                                bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/10 hover:opacity-95 transition"
//                   >
//                     INQUIRE NOW
//                     <ArrowRight size={18} className="ml-2" />
//                   </motion.a>

//                   <p className="mt-3 text-xs text-[#2B2B2B]/60 text-center">
//                     We’ll respond with pricing, MOQs, lead time & packaging
//                     options.
//                   </p>
//                 </div>
//               </motion.div>

//               <motion.div
//                 variants={fadeUp}
//                 initial="hidden"
//                 whileInView="show"
//                 viewport={{ once: true, amount: 0.25 }}
//                 className="rounded-2xl border border-black/10 bg-white shadow-sm p-6"
//               >
//                 <h4 className="text-sm font-semibold uppercase tracking-[0.22em] text-[#2B2B2B]/70">
//                   Why Amera for Shilajit?
//                 </h4>

//                 <div className="mt-4 space-y-3">
//                   {[
//                     {
//                       icon: ShieldCheck,
//                       title: "Quality-controlled process",
//                       desc: "Systematic encapsulation with compliance-first QC.",
//                     },
//                     {
//                       icon: Package,
//                       title: "Private label ready",
//                       desc: "Packaging & labeling options for brand growth.",
//                     },
//                     {
//                       icon: Factory,
//                       title: "Scalable manufacturing",
//                       desc: "From pilot to bulk with consistent output.",
//                     },
//                   ].map((x) => (
//                     <div
//                       key={x.title}
//                       className="flex items-start gap-3 rounded-xl border border-black/10 bg-white p-4"
//                     >
//                       <div className="h-10 w-10 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                         <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                           <x.icon size={18} className="text-[#C62828]" />
//                         </div>
//                       </div>
//                       <div>
//                         <p className="text-sm font-semibold text-[#1B1B1B]">
//                           {x.title}
//                         </p>
//                         <p className="mt-1 text-sm text-[#2B2B2B]/75 leading-6">
//                           {x.desc}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </motion.div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom CTA band */}
//         <div className="mt-10 rounded-2xl border border-black/10 bg-gradient-to-r from-[#FFF8F3] to-white p-6 md:p-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
//           <div>
//             <p className="text-sm font-semibold text-[#1B1B1B]">
//               Want Shilajit in other formats too?
//             </p>
//             <p className="mt-1 text-sm text-[#2B2B2B]/75">
//               Ask for resin, powder, gummies, or custom blends — we’ll share
//               options.
//             </p>
//           </div>
//           <motion.a
//             whileHover={{ y: -2 }}
//             whileTap={{ scale: 0.98 }}
//             href="/contact"
//             className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm font-semibold text-white
//                        bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/10 hover:opacity-95 transition"
//           >
//             Request a Quote
//             <ArrowRight size={18} className="ml-2" />
//           </motion.a>
//         </div>
//       </section>

//       {/* local keyframes */}
//       <style>{`
//         @keyframes shimmer {
//           0% { background-position: 200% 0; }
//           100% { background-position: -200% 0; }
//         }
//       `}</style>
//     </div>
//   );
// }

// function TabContent({ tab }: { tab: TabKey }) {
//   // You can replace the content below with your exact copy anytime.
//   if (tab === "info") {
//     return (
//       <div>
//         <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//           Product Information
//         </h3>
//         <p className="mt-3 text-sm md:text-base text-[#2B2B2B]/80 leading-relaxed">
//           Amera Exports provides integrated manufacturing for Shilajit Capsules
//           with private labeling support. We help brands streamline sourcing,
//           encapsulation, packaging, and export readiness—built for global markets.
//         </p>

//         <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
//           {[
//             { icon: Package, title: "Private Label Ready", desc: "Branding & packaging support." },
//             { icon: ShieldCheck, title: "Quality First", desc: "Process-driven QC checkpoints." },
//             { icon: Factory, title: "Scalable Output", desc: "From small batches to bulk runs." },
//           ].map((x) => (
//             <div
//               key={x.title}
//               className="rounded-2xl border border-black/10 bg-white p-5 shadow-sm"
//             >
//               <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                 <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                   <x.icon size={18} className="text-[#C62828]" />
//                 </div>
//               </div>
//               <p className="mt-3 font-semibold text-[#1B1B1B]">{x.title}</p>
//               <p className="mt-1 text-sm text-[#2B2B2B]/75 leading-6">{x.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (tab === "spec") {
//     return (
//       <div>
//         <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//           Product Specification
//         </h3>

//         <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
//           {[
//             { k: "Product Type", v: "Shilajit Capsules" },
//             { k: "Manufacturing", v: "Private Label / OEM / ODM" },
//             { k: "Facilities", v: "Advanced machinery & systematic encapsulation" },
//             { k: "Extended Line", v: "Resin, Powder, Gummies & more" },
//           ].map((row) => (
//             <div
//               key={row.k}
//               className="rounded-2xl border border-black/10 bg-white p-5"
//             >
//               <p className="text-xs font-semibold tracking-[0.22em] uppercase text-[#2B2B2B]/60">
//                 {row.k}
//               </p>
//               <p className="mt-2 text-sm md:text-base font-semibold text-[#1B1B1B]">
//                 {row.v}
//               </p>
//             </div>
//           ))}
//         </div>

//         <div className="mt-6 rounded-2xl border border-black/10 bg-white p-5">
//           <p className="text-sm text-[#2B2B2B]/80 leading-7">
//             Share your target market, capsule format, label requirements, and order
//             volume—our team will recommend the best path for production and packaging.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (tab === "dosage") {
//     return (
//       <div>
//         <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//           Dosage & Usage
//         </h3>

//         <div className="mt-4 rounded-2xl border border-black/10 bg-white p-5">
//           <p className="text-sm md:text-base text-[#2B2B2B]/80 leading-relaxed">
//             Dosage guidelines depend on formulation strength and market compliance.
//             For private label manufacturing, we align dosage recommendations with
//             your regulatory and branding needs.
//           </p>
//         </div>

//         <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
//           {[
//             { icon: ClipboardList, title: "Label Guidance", desc: "Market-aligned directions." },
//             { icon: ShieldCheck, title: "Compliance-first", desc: "Built around export standards." },
//             { icon: Leaf, title: "Formulation Options", desc: "Custom blends available." },
//           ].map((x) => (
//             <div
//               key={x.title}
//               className="rounded-2xl border border-black/10 bg-white p-5 shadow-sm"
//             >
//               <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                 <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                   <x.icon size={18} className="text-[#C62828]" />
//                 </div>
//               </div>
//               <p className="mt-3 font-semibold text-[#1B1B1B]">{x.title}</p>
//               <p className="mt-1 text-sm text-[#2B2B2B]/75 leading-6">{x.desc}</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (tab === "quality") {
//     return (
//       <div>
//         <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//           Quality & Appearance
//         </h3>

//         <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
//           {[
//             {
//               icon: ShieldCheck,
//               title: "Rigor in QC",
//               desc: "Quality control protocols built into each stage of manufacturing.",
//             },
//             {
//               icon: BadgeCheck,
//               title: "Export-oriented standards",
//               desc: "Process alignment for global market requirements.",
//             },
//             {
//               icon: Package,
//               title: "Sealed & protected",
//               desc: "Moisture-resistant packaging options for shelf stability.",
//             },
//             {
//               icon: Leaf,
//               title: "Natural profile",
//               desc: "Curated product positioning based on your brand direction.",
//             },
//           ].map((x) => (
//             <div
//               key={x.title}
//               className="rounded-2xl border border-black/10 bg-white p-5"
//             >
//               <div className="flex items-start gap-3">
//                 <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                   <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                     <x.icon size={18} className="text-[#C62828]" />
//                   </div>
//                 </div>
//                 <div>
//                   <p className="font-semibold text-[#1B1B1B]">{x.title}</p>
//                   <p className="mt-1 text-sm text-[#2B2B2B]/75 leading-6">{x.desc}</p>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="mt-6 rounded-2xl border border-black/10 bg-white p-5">
//           <p className="text-sm text-[#2B2B2B]/80 leading-7">
//             For specific COA/testing details, share your target regulations (USA/EU/UK/Middle East)
//             and we’ll propose the most suitable testing workflow.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (tab === "pricing") {
//     return (
//       <div>
//         <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//           Pricing & Supply
//         </h3>

//         <div className="mt-4 rounded-2xl border border-black/10 bg-white p-5">
//           <p className="text-sm md:text-base text-[#2B2B2B]/80 leading-relaxed">
//             Pricing depends on formulation, capsule count, packaging format, MOQ, and destination
//             compliance requirements. We support bulk manufacturing and export-ready supply.
//           </p>
//         </div>

//         <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
//           {[
//             { icon: Factory, title: "MOQs", desc: "Flexible based on format." },
//             { icon: Package, title: "Packaging", desc: "Bottle / blister / bulk." },
//             { icon: Truck, title: "Lead Time", desc: "Planned for export cycles." },
//           ].map((x) => (
//             <div
//               key={x.title}
//               className="rounded-2xl border border-black/10 bg-white p-5 shadow-sm"
//             >
//               <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//                 <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//                   <x.icon size={18} className="text-[#C62828]" />
//                 </div>
//               </div>
//               <p className="mt-3 font-semibold text-[#1B1B1B]">{x.title}</p>
//               <p className="mt-1 text-sm text-[#2B2B2B]/75 leading-6">{x.desc}</p>
//             </div>
//           ))}
//         </div>

//         <div className="mt-6 rounded-2xl border border-black/10 bg-gradient-to-r from-[#FFF8F3] to-white p-5">
//           <p className="text-sm font-semibold text-[#1B1B1B]">
//             Fastest way to get pricing:
//           </p>
//           <p className="mt-1 text-sm text-[#2B2B2B]/75">
//             Tell us capsule count, bottle/blister/bulk, MOQ, and destination market.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   // packaging
//   return (
//     <div>
//       <h3 className="text-xl md:text-2xl font-bold text-[#1B1B1B]">
//         Packaging & Storage
//       </h3>

//       <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
//         <InfoCard
//           icon={Box}
//           title="Packaging Details"
//           points={[
//             "Secure, moisture-resistant packaging to maintain freshness",
//             "Available in bottle, blister packs, or bulk packaging",
//             "Labeling support for private brands",
//           ]}
//         />
//         <InfoCard
//           icon={Package}
//           title="Storage"
//           points={[
//             "Long shelf life when stored in cool, dry conditions",
//             "Avoid direct sunlight and high humidity",
//             "Export packing options available",
//           ]}
//         />
//       </div>

//       <div className="mt-6 rounded-2xl border border-black/10 bg-white p-5">
//         <p className="text-sm text-[#2B2B2B]/80 leading-7">
//           Need custom packaging design? We can align packaging format and labeling
//           with your brand style and target market requirements.
//         </p>
//       </div>
//     </div>
//   );
// }

// function InfoCard({
//   icon: Icon,
//   title,
//   points,
// }: {
//   icon: any;
//   title: string;
//   points: string[];
// }) {
//   const [open, setOpen] = useState(true);

//   return (
//     <div className="rounded-2xl border border-black/10 bg-white overflow-hidden">
//       <button
//         onClick={() => setOpen((s) => !s)}
//         className="w-full flex items-center justify-between gap-4 p-5 text-left"
//       >
//         <div className="flex items-center gap-3">
//           <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
//             <div className="h-full w-full rounded-xl bg-white flex items-center justify-center">
//               <Icon size={18} className="text-[#C62828]" />
//             </div>
//           </div>
//           <div>
//             <p className="font-semibold text-[#1B1B1B]">{title}</p>
//             <p className="text-sm text-[#2B2B2B]/60">
//               Click to {open ? "collapse" : "expand"}
//             </p>
//           </div>
//         </div>

//         <ChevronDown
//           className={`transition ${open ? "rotate-180" : "rotate-0"}`}
//           size={18}
//         />
//       </button>

//       <AnimatePresence initial={false}>
//         {open && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             transition={{ duration: 0.25 }}
//             className="px-5 pb-5"
//           >
//             <div className="space-y-3">
//               {points.map((p) => (
//                 <div key={p} className="flex items-start gap-3">
//                   <span className="mt-2 h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
//                   <p className="text-sm text-[#2B2B2B]/80 leading-6">{p}</p>
//                 </div>
//               ))}
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }

import React, { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ArrowRight,
  BadgeCheck,
  Box,
  ChevronDown,
  ClipboardList,
  Factory,
  Leaf,
  Package,
  PhoneCall,
  ShieldCheck,
  Star,
  Truck,
  Info,
  TestTube2,
  CheckCircle2,
} from "lucide-react";

/**
 * ✅ Replace these URLs with your own product images:
 * import img1 from "../assets/products/shilajit/1.jpg";

 */

 import img1 from "../../assets/products/shilajit/shilajit-capsule.png";
import img2 from "../../assets/products/shilajit/shilajit-resin.png";
import img3 from "../../assets/products/shilajit/shilajit-resin1.png";
import img4 from "../../assets/products/shilajit/shilajit-resin2.png";
import img5 from "../../assets/products/shilajit/shilajit-resin3.png";

type TabKey =
  | "info"
  | "spec"
  | "dosage"
  | "quality"
  | "pricing"
  | "packaging";

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

const shimmer =
  "bg-[linear-gradient(110deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.35)_35%,rgba(255,255,255,0)_70%)] bg-[length:200%_100%]";

const pills = [
  "500mg",
  "750mg",
  "1000mg",
  "Capsules",
  "Tablets",
  "Resin",
  "Powder",
  "Gummies",
];

export default function ShilajitProductPage() {
  const images = useMemo(
    () => [
    //   "https://images.unsplash.com/photo-1616671276441-2f2cf7b1d37a?auto=format&fit=crop&w=1400&q=80",
    //   "https://images.unsplash.com/photo-1585232351009-aa87416fca90?auto=format&fit=crop&w=1400&q=80",
    //   "https://images.unsplash.com/photo-1607619056574-7b8d3ee536b2?auto=format&fit=crop&w=1400&q=80",
    //   "https://images.unsplash.com/photo-1584017911766-d451b3d0e843?auto=format&fit=crop&w=1400&q=80",
        img1,
    img2,
    img3,
    img4,
    img5,
    ],
    []
  );

  const [activeImg, setActiveImg] = useState(0);
  const [tab, setTab] = useState<TabKey>("info");

  const tabs: { key: TabKey; label: string; icon: any }[] = [
    { key: "info", label: "Product Information", icon: ClipboardList },
    { key: "spec", label: "Production Specification", icon: Factory },
    { key: "dosage", label: "Dosage & Usage", icon: TestTube2 },
    { key: "quality", label: "Quality & Appearance", icon: ShieldCheck },
    { key: "pricing", label: "Pricing & Supply", icon: Truck },
    { key: "packaging", label: "Packaging & Storage", icon: Box },
  ];

  return (
    <div className="relative overflow-hidden bg-[#070A0F] text-white">
      {/* ===== Premium background (dark, elegant, animated) ===== */}
      <div className="pointer-events-none absolute inset-0">
        {/* base gradient */}
        <div className="absolute inset-0 bg-[radial-gradient(1100px_circle_at_10%_0%,rgba(244,124,32,0.22),transparent_60%),radial-gradient(1000px_circle_at_90%_10%,rgba(232,62,111,0.18),transparent_58%),radial-gradient(900px_circle_at_60%_95%,rgba(201,162,39,0.14),transparent_55%)]" />
        {/* vignette */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_40%,rgba(0,0,0,0.65)_100%)]" />
        {/* subtle noise */}
        <div className="absolute inset-0 opacity-[0.14] mix-blend-soft-light bg-[url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22160%22 height=%22160%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22160%22 height=%22160%22 filter=%22url(%23n)%22 opacity=%220.55%22/%3E%3C/svg%3E')]" />
      </div>

      {/* floating “model-like” elements (pure CSS/Framer, no three.js) */}
      <OrbsAndRings />

      {/* ===== HERO ===== */}
      <section className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 pt-12 md:pt-16 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          {/* Left */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            className="lg:col-span-6"
          >
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 backdrop-blur">
              <BadgeCheck size={16} className="text-[#F47C20]" />
              <span className="text-xs font-semibold tracking-[0.22em] uppercase text-white/70">
                Shilajit Capsules • Private Label / OEM / ODM
              </span>
            </div>

            <h1 className="mt-6 text-4xl md:text-5xl font-extrabold leading-tight text-white">
              Curated to meet needs, right from the lap of nature —{" "}
              <span className="bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
                Shilajit Capsules
              </span>
            </h1>

            <p className="mt-6 text-base md:text-lg leading-relaxed text-white/75">
              Amera Exports provides fully integrated manufacturing for Shilajit
              Capsules and supports your brand with streamlined private labeling,
              packaging, and export-ready compliance.
            </p>

            <p className="mt-4 text-base md:text-lg leading-relaxed text-white/75">
              Our product line also includes Shilajit resin, Shilajit powder,
              Shilajit gummies, and custom blends — manufactured systematically
              with quality-first processes.
            </p>

            {/* Chips */}
            <div className="mt-7 flex flex-wrap items-center gap-3">
              {[
                { label: "Export-ready", icon: Truck },
                { label: "CGMP / HACCP aligned", icon: ShieldCheck },
                { label: "Private label", icon: Package },
                { label: "Bulk supply", icon: Factory },
              ].map((c) => (
                <span
                  key={c.label}
                  className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-sm text-white/70"
                >
                  <c.icon size={14} className="text-[#F47C20]" />
                  {c.label}
                </span>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <motion.a
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                href="/contact"
                className="relative inline-flex items-center justify-center rounded-md px-7 py-3 text-sm font-semibold text-white
                           bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-lg shadow-black/30 hover:opacity-95 transition"
              >
                INQUIRE NOW
                <ArrowRight size={18} className="ml-2" />
                <span
                  className={`pointer-events-none absolute inset-0 rounded-md ${shimmer} opacity-40`}
                  style={{ animation: "shimmer 3.2s linear infinite" }}
                />
              </motion.a>

              <motion.a
                whileHover={{ y: -2 }}
                whileTap={{ scale: 0.98 }}
                href="tel:+916387961502"
                className="inline-flex items-center justify-center rounded-md px-7 py-3 text-sm font-semibold
                           border border-white/12 bg-white/5 text-white hover:border-white/25 transition"
              >
                <PhoneCall size={18} className="mr-2 text-[#F47C20]" />
                Talk to Sales
              </motion.a>
            </div>

            <div className="mt-10 flex items-center gap-3 text-sm text-white/65">
              <div className="flex items-center gap-1 text-[#F47C20]">
                <Star size={16} fill="currentColor" />
                <Star size={16} fill="currentColor" />
                <Star size={16} fill="currentColor" />
                <Star size={16} fill="currentColor" />
                <Star size={16} fill="currentColor" />
              </div>
              <span>Trusted by global brands in USA & Europe</span>
            </div>

            {/* Dosage “pills” preview */}
            <div className="mt-8">
              <p className="text-xs font-semibold tracking-[0.22em] uppercase text-white/55">
                Common formats we can manufacture
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                {pills.map((p) => (
                  <span
                    key={p}
                    className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-white/70"
                  >
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Right gallery */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.25 }}
            className="lg:col-span-6"
          >
            <div className="relative">
              <div className="rounded-2xl border border-white/10 bg-white/6 backdrop-blur shadow-[0_30px_90px_rgba(0,0,0,0.45)] overflow-hidden">
                <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

                <div className="p-4 md:p-6">
                  {/* main image */}
                  <div className="relative rounded-2xl overflow-hidden border border-white/10 bg-black/25">
                    <motion.img
                      key={images[activeImg]}
                      src={images[activeImg]}
                      alt="Shilajit Capsules"
                      className="w-full h-[300px] md:h-[380px] object-cover"
                      initial={{ opacity: 0, scale: 0.985 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.35 }}
                      draggable={false}
                    />
                    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(700px_circle_at_20%_10%,rgba(244,124,32,0.18),transparent_55%),radial-gradient(700px_circle_at_90%_30%,rgba(232,62,111,0.14),transparent_55%)]" />

                    <motion.div
                      animate={{ y: [0, -8, 0] }}
                      transition={{ repeat: Infinity, duration: 6 }}
                      className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-black/35 backdrop-blur border border-white/10 px-3 py-2 text-xs font-semibold text-white/80"
                    >
                      <Leaf size={14} className="text-[#F47C20]" />
                      Natural • Potency-focused • Private Label
                    </motion.div>
                  </div>

                  {/* thumbs */}
                  <div className="mt-4 grid grid-cols-4 gap-3">
                    {images.map((src, i) => (
                      <button
                        key={src}
                        onClick={() => setActiveImg(i)}
                        className={`relative rounded-xl overflow-hidden border transition ${
                          i === activeImg
                            ? "border-transparent ring-2 ring-[#E83E6F]/40"
                            : "border-white/10 hover:border-white/20"
                        }`}
                        aria-label={`View image ${i + 1}`}
                      >
                        <img
                          src={src}
                          alt="thumb"
                          className="h-16 md:h-20 w-full object-cover"
                          draggable={false}
                        />
                        {i === activeImg && (
                          <div className="absolute inset-0 bg-gradient-to-r from-[#F47C20]/15 to-[#E83E6F]/15" />
                        )}
                      </button>
                    ))}
                  </div>

                  {/* mini metrics */}
                  <div className="mt-5 grid grid-cols-3 gap-3">
                    {[
                      { k: "Form", v: "Capsules" },
                      { k: "Strength", v: "500–1000mg" },
                      { k: "Packaging", v: "Bottle/Blister" },
                    ].map((m) => (
                      <div
                        key={m.k}
                        className="rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-center"
                      >
                        <div className="text-sm font-bold text-[#F47C20]">
                          {m.k}
                        </div>
                        <div className="text-[11px] md:text-xs text-white/65">
                          {m.v}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* ambient blobs */}
              <div className="pointer-events-none absolute -top-16 -right-16 h-64 w-64 rounded-full bg-[#E83E6F]/18 blur-3xl" />
              <div className="pointer-events-none absolute -bottom-20 -left-20 h-72 w-72 rounded-full bg-[#F47C20]/18 blur-3xl" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* ===== DETAILS ===== */}
      <section className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-8">
            <div className="rounded-2xl border border-white/10 bg-white/6 backdrop-blur shadow-sm overflow-hidden">
              <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />

              {/* tabs */}
              <div className="p-4 md:p-6 border-b border-white/10">
                <div className="flex flex-wrap gap-2">
                  {tabs.map((t) => {
                    const Icon = t.icon;
                    const active = tab === t.key;
                    return (
                      <button
                        key={t.key}
                        onClick={() => setTab(t.key)}
                        className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition border ${
                          active
                            ? "bg-gradient-to-r from-[#F47C20] to-[#E83E6F] text-white border-transparent shadow-sm"
                            : "bg-white/5 text-white/75 border-white/10 hover:border-white/20"
                        }`}
                      >
                        <Icon size={16} />
                        {t.label}
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* tab content */}
              <div className="p-5 md:p-7">
                <AnimatePresence mode="wait">
                  <motion.div
                    key={tab}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.25 }}
                  >
                    <TabContent tab={tab} />
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>

          {/* Right: Sticky */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-24 space-y-6">
              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.25 }}
                className="rounded-2xl border border-white/10 bg-white/6 backdrop-blur shadow-sm overflow-hidden"
              >
                <div className="h-[4px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]" />
                <div className="p-6">
                  <h3 className="text-lg font-bold text-white">
                    Packaging Details
                  </h3>
                  <p className="mt-2 text-sm text-white/70 leading-6">
                    Secure, moisture-resistant packaging to maintain freshness.
                  </p>

                  <div className="mt-5 space-y-3">
                    {[
                      "Available in bottle, blister packs, or bulk packaging",
                      "Long shelf life when stored in cool, dry conditions",
                      "Labeling support for private brands",
                    ].map((b) => (
                      <div key={b} className="flex items-start gap-3">
                        <span className="mt-2 h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
                        <p className="text-sm text-white/75">{b}</p>
                      </div>
                    ))}
                  </div>

                  <motion.a
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.98 }}
                    href="/contact"
                    className="mt-6 inline-flex w-full items-center justify-center rounded-md px-6 py-3 text-sm font-semibold text-white
                               bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/30 hover:opacity-95 transition"
                  >
                    INQUIRE NOW
                    <ArrowRight size={18} className="ml-2" />
                  </motion.a>

                  <p className="mt-3 text-xs text-white/55 text-center">
                    We’ll respond with pricing, MOQs, lead time & packaging options.
                  </p>
                </div>
              </motion.div>

              <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, amount: 0.25 }}
                className="rounded-2xl border border-white/10 bg-white/6 backdrop-blur shadow-sm p-6"
              >
                <h4 className="text-xs font-semibold uppercase tracking-[0.22em] text-white/60">
                  Quick Spec Snapshot
                </h4>

                <div className="mt-4 space-y-3">
                  <MiniSpec k="Available Strengths" v="500mg / 750mg / 1000mg (custom)" />
                  <MiniSpec k="Capsule Options" v="Veg / Gelatin (as required)" />
                  <MiniSpec k="MOQ" v="Depends on packaging & market" />
                  <MiniSpec k="Lead Time" v="Depends on batch size & approvals" />
                </div>

                <div className="mt-5 rounded-xl border border-white/10 bg-white/5 p-4">
                  <div className="flex items-start gap-3">
                    <Info size={18} className="text-[#F47C20] mt-0.5" />
                    <p className="text-sm text-white/70 leading-6">
                      Final dosage & label claims are aligned to your target market
                      regulations (USA/EU/etc.) and your brand positioning.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* bottom CTA */}
        <div className="mt-10 rounded-2xl border border-white/10 bg-white/6 backdrop-blur p-6 md:p-7 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-white">
              Want Shilajit in other formats too?
            </p>
            <p className="mt-1 text-sm text-white/70">
              Ask for resin, powder, gummies, or custom blends — we’ll share options.
            </p>
          </div>
          <motion.a
            whileHover={{ y: -2 }}
            whileTap={{ scale: 0.98 }}
            href="/contact"
            className="inline-flex items-center justify-center rounded-md px-6 py-3 text-sm font-semibold text-white
                       bg-gradient-to-r from-[#F47C20] to-[#E83E6F] shadow-md shadow-black/30 hover:opacity-95 transition"
          >
            Request a Quote
            <ArrowRight size={18} className="ml-2" />
          </motion.a>
        </div>
      </section>

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}

/* ===========================
   TAB CONTENT (with dosages)
=========================== */
function TabContent({ tab }: { tab: TabKey }) {
  if (tab === "info") {
    return (
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-white">
          Product Information
        </h3>
        <p className="mt-3 text-sm md:text-base text-white/75 leading-relaxed">
          Amera Exports provides integrated manufacturing for Shilajit Capsules
          with private labeling support. We streamline sourcing, encapsulation,
          packaging, and export readiness—built for global markets.
        </p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <DarkCard
            icon={Package}
            title="Private Label Ready"
            desc="Branding & packaging support."
          />
          <DarkCard
            icon={ShieldCheck}
            title="Quality First"
            desc="Compliance-first QC checkpoints."
          />
          <DarkCard
            icon={Factory}
            title="Scalable Output"
            desc="Pilot to bulk with consistency."
          />
        </div>
      </div>
    );
  }

  if (tab === "spec") {
    return (
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-white">
          Production Specification
        </h3>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <SpecRow k="Product Type" v="Shilajit Capsules (Private Label / OEM / ODM)" />
          <SpecRow k="Strength Options" v="500mg / 750mg / 1000mg (custom available)" />
          <SpecRow k="Capsule Shell" v="Vegetarian / Gelatin (as per requirement)" />
          <SpecRow k="Fill Format" v="Powder / standardized blend (as per formulation)" />
          <SpecRow k="Other Formats" v="Resin, Powder, Gummies, custom blends" />
          <SpecRow k="Packaging" v="Bottle / Blister / Bulk export packing" />
        </div>

        <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5">
          <p className="text-sm text-white/75 leading-7">
            Share your target market (USA/EU/etc.), capsule count per bottle,
            label claims, and MOQ—our team will propose a production plan,
            approvals timeline, and packaging options.
          </p>
        </div>
      </div>
    );
  }

  if (tab === "dosage") {
    return (
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-white">
          Dosage & Usage (Brand-ready)
        </h3>

        <p className="mt-3 text-sm md:text-base text-white/75 leading-relaxed">
          Final dosage and label directions depend on your product strength,
          formulation, and target market compliance. Below are common private
          label-ready dosage ranges that brands usually request.
        </p>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <DoseCard
            title="Standard Daily"
            range="500–1000mg / day"
            notes={["Common for daily wellness", "Usually split 1–2 servings"]}
          />
          <DoseCard
            title="Performance Focus"
            range="1000–2000mg / day"
            notes={["Requested for stamina & vitality", "Depends on brand claims"]}
          />
          <DoseCard
            title="Beginner / Trial"
            range="250–500mg / day"
            notes={["Lower strength options", "Great for entry SKUs"]}
          />
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <DarkCard
            icon={ClipboardList}
            title="Label Directions"
            desc="We help align directions with your market and compliance needs."
          />
          <DarkCard
            icon={CheckCircle2}
            title="Custom Formulations"
            desc="Combine Shilajit with adaptogens or vitamins for custom SKUs."
          />
        </div>

        <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5">
          <p className="text-sm text-white/75 leading-7">
            ✅ Want exact dose + bottle count suggestions? Share: (1) target market,
            (2) brand positioning (premium/entry), (3) capsule size preference, and
            (4) whether you want single-ingredient or blend. We’ll recommend best options.
          </p>
        </div>
      </div>
    );
  }

  if (tab === "quality") {
    return (
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-white">
          Quality & Appearance
        </h3>

        <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <DarkCard
            icon={ShieldCheck}
            title="QC at Each Stage"
            desc="Protocols integrated from procurement to final packing."
          />
          <DarkCard
            icon={BadgeCheck}
            title="Export-oriented"
            desc="Aligned to international market expectations and documentation."
          />
          <DarkCard
            icon={Package}
            title="Sealed & Protected"
            desc="Moisture-resistant packaging options for shelf stability."
          />
          <DarkCard
            icon={Leaf}
            title="Natural Profile"
            desc="Positioning options: pure, blends, performance ranges."
          />
        </div>

        <div className="mt-6 rounded-2xl border border-white/10 bg-white/5 p-5">
          <p className="text-sm text-white/75 leading-7">
            For COA / third-party testing workflows, share your destination market
            requirements and we’ll align a testing plan accordingly.
          </p>
        </div>
      </div>
    );
  }

  if (tab === "pricing") {
    return (
      <div>
        <h3 className="text-xl md:text-2xl font-bold text-white">
          Pricing & Supply
        </h3>

        <div className="mt-4 rounded-2xl border border-white/10 bg-white/5 p-5">
          <p className="text-sm md:text-base text-white/75 leading-relaxed">
            Pricing depends on formulation, capsule strength, capsule count,
            packaging format, MOQ, and export compliance needs.
          </p>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <DarkCard icon={Factory} title="MOQ" desc="Depends on packaging & market." />
          <DarkCard icon={Package} title="Packaging" desc="Bottle / blister / bulk." />
          <DarkCard icon={Truck} title="Lead Time" desc="Planned for export cycles." />
        </div>
      </div>
    );
  }

  // packaging
  return (
    <div>
      <h3 className="text-xl md:text-2xl font-bold text-white">
        Packaging & Storage
      </h3>

      <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-4">
        <AccordionCard
          icon={Box}
          title="Packaging Details"
          points={[
            "Secure, moisture-resistant packaging to maintain freshness",
            "Available in bottle, blister packs, or bulk packaging",
            "Labeling support for private brands",
          ]}
        />
        <AccordionCard
          icon={Package}
          title="Storage"
          points={[
            "Long shelf life when stored in cool, dry conditions",
            "Avoid direct sunlight and high humidity",
            "Export packing options available",
          ]}
        />
      </div>
    </div>
  );
}

/* ===========================
   SMALL UI HELPERS
=========================== */

function SpecRow({ k, v }: { k: string; v: string }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <p className="text-xs font-semibold tracking-[0.22em] uppercase text-white/55">
        {k}
      </p>
      <p className="mt-2 text-sm md:text-base font-semibold text-white">
        {v}
      </p>
    </div>
  );
}

function DarkCard({
  icon: Icon,
  title,
  desc,
}: {
  icon: any;
  title: string;
  desc: string;
}) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-5">
      <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
        <div className="h-full w-full rounded-xl bg-[#070A0F] flex items-center justify-center">
          <Icon size={18} className="text-[#F47C20]" />
        </div>
      </div>
      <p className="mt-3 font-semibold text-white">{title}</p>
      <p className="mt-1 text-sm text-white/70 leading-6">{desc}</p>
    </div>
  );
}

function DoseCard({
  title,
  range,
  notes,
}: {
  title: string;
  range: string;
  notes: string[];
}) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 p-5 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-12 -right-12 h-40 w-40 rounded-full bg-[#E83E6F]/15 blur-3xl" />
      <p className="text-xs font-semibold tracking-[0.22em] uppercase text-white/55">
        {title}
      </p>
      <p className="mt-2 text-2xl font-extrabold bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent">
        {range}
      </p>
      <div className="mt-4 space-y-2">
        {notes.map((n) => (
          <div key={n} className="flex items-start gap-2 text-sm text-white/70">
            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
            <span>{n}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function MiniSpec({ k, v }: { k: string; v: string }) {
  return (
    <div className="flex items-start justify-between gap-4 rounded-xl border border-white/10 bg-white/5 px-4 py-3">
      <div className="text-xs text-white/55">{k}</div>
      <div className="text-sm font-semibold text-white text-right">{v}</div>
    </div>
  );
}

function AccordionCard({
  icon: Icon,
  title,
  points,
}: {
  icon: any;
  title: string;
  points: string[];
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="rounded-2xl border border-white/10 bg-white/5 overflow-hidden">
      <button
        onClick={() => setOpen((s) => !s)}
        className="w-full flex items-center justify-between gap-4 p-5 text-left"
      >
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-gradient-to-r from-[#F47C20] to-[#E83E6F] p-[1px]">
            <div className="h-full w-full rounded-xl bg-[#070A0F] flex items-center justify-center">
              <Icon size={18} className="text-[#F47C20]" />
            </div>
          </div>
          <div>
            <p className="font-semibold text-white">{title}</p>
            <p className="text-sm text-white/55">Click to {open ? "collapse" : "expand"}</p>
          </div>
        </div>

        <ChevronDown
          className={`transition ${open ? "rotate-180" : "rotate-0"} text-white/70`}
          size={18}
        />
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="px-5 pb-5"
          >
            <div className="space-y-3">
              {points.map((p) => (
                <div key={p} className="flex items-start gap-3">
                  <span className="mt-2 h-2 w-2 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]" />
                  <p className="text-sm text-white/75 leading-6">{p}</p>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

/* ===========================
   BACKGROUND “MODEL” ELEMENTS
   (no three.js, no TS errors)
=========================== */
function OrbsAndRings() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* big orb */}
      <motion.div
        className="absolute -top-24 -left-28 h-[520px] w-[520px] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, rgba(244,124,32,0.35), transparent 55%), radial-gradient(circle at 70% 70%, rgba(232,62,111,0.28), transparent 60%)",
        }}
        animate={{ x: [0, 22, 0], y: [0, 14, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
      />
      {/* right orb */}
      <motion.div
        className="absolute -bottom-32 -right-40 h-[620px] w-[620px] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, rgba(232,62,111,0.30), transparent 55%), radial-gradient(circle at 70% 70%, rgba(201,162,39,0.20), transparent 60%)",
        }}
        animate={{ x: [0, -26, 0], y: [0, -16, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* ring cluster */}
      <motion.div
        className="absolute top-32 right-16 h-72 w-72 rounded-full border border-white/10"
        animate={{ rotate: 360 }}
        transition={{ duration: 24, repeat: Infinity, ease: "linear" }}
      />
      <motion.div
        className="absolute top-40 right-24 h-56 w-56 rounded-full border border-white/10"
        animate={{ rotate: -360 }}
        transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
      />

      {/* floating spark dots */}
      <div className="absolute inset-0">
        {Array.from({ length: 18 }).map((_, i) => (
          <motion.span
            key={i}
            className="absolute h-1.5 w-1.5 rounded-full"
            style={{
              left: `${(i * 7) % 100}%`,
              top: `${(i * 11) % 100}%`,
              background:
                i % 3 === 0
                  ? "rgba(244,124,32,0.75)"
                  : i % 3 === 1
                  ? "rgba(232,62,111,0.65)"
                  : "rgba(201,162,39,0.55)",
              boxShadow: "0 0 18px rgba(244,124,32,0.25)",
            }}
            animate={{ y: [0, -10, 0], opacity: [0.55, 0.9, 0.55] }}
            transition={{
              duration: 4 + (i % 5),
              repeat: Infinity,
              ease: "easeInOut",
              delay: (i % 6) * 0.2,
            }}
          />
        ))}
      </div>
    </div>
  );
}